import standardEquation from './standard'
import californiaEquation from './ca'
import delawareEquation from './de.js'
import connecticutEquation from './ct.js'
import coloradoEquation from './co.js'
import indianaEquation from './in'
import mississippiEquation from './ms'
import missouriEquation from './mo'
import newYorkEquation from './ny'
import louisianaEquation from './la'
import southCarolinaEquation from './sc.js'
import texasEquation from './tx'

const equation = (bondValue, premium, state, type = 'STATE', additional = {}) => {
  const params = {
    bondValue,
    premium,
    type,
    additional
  }
  if (!state) return null
  state = state.toUpperCase()
  if (state === 'AL') return standardEquation({ bondValue })
  if (state === 'AZ') return standardEquation({ bondValue })
  if (state === 'CA') return californiaEquation(params)
  if (state === 'CO') return coloradoEquation(params)
  if (state === 'CT') return connecticutEquation(params)
  if (state === 'DE') return delawareEquation(params)
  if (state === 'FL') return standardEquation({ bondValue, minimum: 100, percentage: .1 })
  if (state === 'IA') return standardEquation({ bondValue })
  if (state === 'IN') return indianaEquation(params)
  if (state === 'KS') return standardEquation({ bondValue })
  if (state === 'LA') return louisianaEquation(params)
  if (state === 'MD') return standardEquation({ bondValue })
  if (state === 'MI') return standardEquation({ bondValue, minimum: 0, percentage: .1 })
  if (state === 'MO') return missouriEquation(params)
  if (state === 'MS') return mississippiEquation(params)
  if (state === 'MT') return standardEquation({ bondValue })
  if (state === 'NV') return standardEquation({ bondValue, minimum: 50, percentage: .15 })
  if (state === 'NY') return newYorkEquation(params)
  if (state === 'NJ') return standardEquation({ bondValue, minimum: 150, percentage: .1 })
  if (state === 'NC') return standardEquation({ bondValue, minimum: 0, percentage: .15 })
  if (state === 'OH') return standardEquation({ bondValue })
  if (state === 'SC') return southCarolinaEquation(params)
  if (state === 'VT') return standardEquation({ bondValue, minimum: 100, percentage: .1 })
  if (state === 'WA') return standardEquation({ bondValue })
  if (state === 'WV') return standardEquation({ bondValue })
  if (state === 'TX') return texasEquation(params)
}

export default equation